import { ChangeEvent, PropsWithChildren } from 'react';
import { RadioGroup, RadioGroupProps } from '@optimus-web/core';
import { ControllerProps, useControllerWithEventHandler } from '../hooks';

export type FormRadioGroupFieldProps = ControllerProps<string> &
    PropsWithChildren<Omit<RadioGroupProps, 'value' | 'error' | 'onChange'>> & {
        onChange?: (e: ChangeEvent<HTMLInputElement>, value: string) => void;
    };

export const FormRadioGroupField = ({
    defaultValue,
    name,
    onChange,
    rules,
    shouldUnregister,
    transform,
    ...other
}: FormRadioGroupFieldProps) => {
    const { value, error, handleChange, onBlur } = useControllerWithEventHandler({
        defaultValue,
        name,
        onChange,
        rules,
        shouldUnregister,
        transform,
    });
    const props = {
        ...other,
        error,
        name,
        onBlur,
        onChange: (e: ChangeEvent<HTMLInputElement>) => handleChange(e, e.target.value),
        value,
    };

    return <RadioGroup {...props} />;
};
